module.exports = __webpack_public_path__ + "img/watch-logo.32c3db1e.png";